import React from 'react';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
const promises = ['Devolución del 100% de tu dinero', 'Sin formularios', 'Sin drama', 'Sin explicaciones'];
export function GuaranteeSection() {
  return <section aria-labelledby="garantia" className="border-y border-ink-600 bg-ink-800" data-id="element-95" data-mp="9tbe8wppooia">
      <div className="mx-auto grid max-w-5xl gap-10 px-5 py-16 sm:py-20 lg:grid-cols-[auto_1fr] lg:items-start" style={{
      paddingTop: "9px",
      paddingBottom: "10px"
    }} data-id="element-96" data-mp="etpo8kavi8iy">
        

        <div data-id="element-97" data-mp="ntm4pyn4012x">
          <h2 id="garantia" className="font-display text-3xl uppercase leading-tight text-white sm:text-4xl" style={{
          paddingTop: "20px"
        }} data-id="element-98" data-mp="nt2n6j1dfepf">
            Garantía 7 días — sin preguntas
          </h2>
          <p className="mt-5 text-base leading-relaxed text-slate-300" data-id="element-99" data-mp="xivxzhtovpsm">
            Abre el material. Úsalo en la cancha. Si en 7 días no es exactamente lo que esperabas:
          </p>

          <ul className="mt-6 grid gap-3 sm:grid-cols-2" data-id="element-100" data-mp="17hlf38drh67t">
            {promises.map(promise => <li key={promise} className="flex items-center gap-3 text-[15px] text-slate-200" data-id="element-101" data-mp="25rnjh0sl8ott">
                <CheckIcon className="h-5 w-5 shrink-0 text-ball-400" strokeWidth={3} aria-hidden="true" data-id="element-102" data-mp="20t3uerip6wx8" />
                {promise}
              </li>)}
          </ul>

          <p className="mt-8 text-base font-semibold text-white" data-id="element-103" data-mp="1vu0xjucvfx0c">
            Nosotros asumimos todo el riesgo. Tú no tienes nada que perder.
          </p>
          <p className="mt-2 text-sm text-slate-500" data-id="element-104" data-mp="2oiogvke28cb9">
            Tasa de devoluciones Sigma Smart: menos del 1%.
          </p>
        </div>
      </div>
    </section>;
}